import axios from "axios";

const apiUrl = process.env.VUE_APP_APIURL;

const state = () => ({
  clients: [],
  selectedClient: "",
  selectedClientProjects: [],
  selectedProject: "",
  projectCards: [],
  projectMatchups: [],
  projects: [],
  url: apiUrl,
  apiStatus: "",
  packages: [],
  selectedPackage: "",
});

const getters = {
  /***** clients *****/
  getClients: (state) => state.clients,
  getClient: (state) => state.selectedClient,
  getClientById: (state) => (id) => {
    var client = state.clients.find((client) => client.id === id) || null;

    return client.company;
  },
  /***** projects *****/
  getProjects: (state) => state.projects,
  getClientProjects: (state) => state.selectedClientProjects,
  getProject: (state) => state.selectedProject,

  /***** cards *****/
  getProjectCards: (state) => state.projectCards,

  /***** cards *****/
  getProjectMatchups: (state) => state.projectMatchups,

  /**** Packages ******/
  getPackages: (state) => state.packages,
  getPackage: (state) => state.selectedPackage,
};

const mutations = {
  api_request(state) {
    state.apiStatus = "loading";
  },
  api_error(state) {
    state.apiStatus = "error";
  },
  /***** clients  *****/
  clients_success(state, data) {
    state.api_status = "success";
    state.clients = data;
  },
  client_success(state, data) {
    state.api_status = "success";
    state.selectedClient = data;
  },
  /***** projects *****/
  projects_success(state, data) {
    state.apiStatus = "success";
    state.projects = data;
  },
  projectByClient_success(state, data) {
    state.apiStatus = "success";
    state.selectedClientProjects = data;
  },
  project_success(state, data) {
    state.apiStatus = "success";
    state.selectedProject = data;
  },
  project_status_toggle(state) {
    state.selectedProject.isActive = !state.selectedProject.isActive;
  },
  project_compare_toggle(state) {
    state.selectedProject.comapre = !state.selectedProject.compare;
  },
  project_order_toggle(state) {
    state.selectedProject.custom_order = !state.selectedProject.custom_order;
  },
  project_sequences_delete(state) {
    state.selectedProject.count_sequences = 0;
  },
  /***** cards *****/
  projectCards_success(state, data) {
    state.api_status = "success";
    state.projectCards = data;
  },
  /***** matchups *****/
  projectMatchups_success(state, data) {
    state.api_status = "success";
    state.projectMatchups = data;
  },
  /***** packages *****/
  packages_success(state, data) {
    state.apiStatus = "success";
    state.packages = data;
  },
  package_success(state, data) {
    state.apiStatus = "success";
    state.selectedPackage = data;
  },
  package_projects(state, data) {
    state.selectedPackage.projects = data;
  },
  package_project_order(state, { projectId, projectOrder }) {
    var project =
      state.selectedPackage?.projects?.find(
        (project) => project.data.id === projectId
      ) || null;

    if (project) {
      project.order = projectOrder;
    }
  },
};

const actions = {
  /***** client *****/
  fetchClients({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/dashboard/clients`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("clients", data);
          commit("clients_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },

  fetchClient({ commit, rootState }, clientId) {
    return new Promise((resolve, reject) => {
      commit("api_request");
      axios({
        url: `${apiUrl}/api/dashboard/clients/${clientId}`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("selectedClient", data);
          commit("client_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  deleteClient({ commit, rootState }, clientId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/clients/${clientId}/delete`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "DELETE",
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  /***** project *****/

  fetchProjects({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/dashboard/projects`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("projects", data);
          commit("projects_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  fetchClientProjects({ commit, rootState }, clientId) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/dashboard/clients/${clientId}/projects`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("selectedClientProjects", data);
          commit("projectByClient_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  fetchProject({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;

          localStorage.setItem("selectedProject", data);
          commit("project_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  deleteProject({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/delete`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "DELETE",
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  toggleProjectStatus({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/status/toggle`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then((resp) => {
          resolve(resp);
          commit("project_status_toggle");
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  toggleProjectCompare({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/compare/toggle`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then((resp) => {
          resolve(resp);
          commit("project_compare_toggle");
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  toggleProjectOrder({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/order/toggle`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then((resp) => {
          resolve(resp);
          commit("project_order_toggle");
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  deleteProjectSequences({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/sequences/delete`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then((resp) => {
          resolve(resp);
          commit("project_sequences_delete");
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  deleteProjectImages({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/images/delete`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "DELETE",
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  /***** cards *****/

  fetchProjectCards({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/cards`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("projectCards", data);
          commit("projectCards_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  deleteCards({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/cards/delete`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "DELETE",
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  /***** results *****/
  deleteResults({ commit, rootState }, projectId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/projects/${projectId}/results/delete`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "DELETE",
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  /***** package *****/

  fetchPackages({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/dashboard/packages`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("packages", data);
          commit("packages_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  deletePackage({ commit, rootState }, packageId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${apiUrl}/api/dashboard/packages/${packageId}/delete`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "DELETE",
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
  fetchPackage({ commit, rootState }, packageId) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/dashboard/packages/${packageId}`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;

          localStorage.setItem("selectedPackage", data);
          commit("package_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
